import { render, staticRenderFns } from "./MoveToFixedDetailsPopup.vue?vue&type=template&id=4b3278a8&scoped=true"
import script from "./MoveToFixedDetailsPopup.vue?vue&type=script&lang=js"
export * from "./MoveToFixedDetailsPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveToFixedDetailsPopup.vue?vue&type=style&index=0&id=4b3278a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3278a8",
  null
  
)

export default component.exports